import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _number from 'lodash/toNumber';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { EMPTY_OBJECT, AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { IUseCreateProps } from '../../types';

const useCreate = () => {
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { createConfiscationAndRefundRequest } = useService();

	const handleFormSubmit = async (submittedData: IUseCreateProps) => {
		setShowLoader(true);
		try {
			let formData;
			if (!_isNil(submittedData.amount) && !_isEmpty(submittedData.amount)) {
				formData = { ...submittedData, amount: _number(submittedData.amount) };
			} else {
				formData = {
					uid: submittedData.uid,
					transactionId: submittedData.transactionId,
					refundType: submittedData.refundType,
					freshdeskTicketId: submittedData.freshdeskTicketId,
					reportedBy: submittedData.reportedBy,
					reportedOn: submittedData.reportedOn,
					confiscationType: submittedData.confiscationType
				};
			}
			await createConfiscationAndRefundRequest(formData);
			showAlert('Confiscation request created sucessfully!', { type: 'success' });
			setShowLoader(false);
			history.goBack();
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while creating the confiscation request', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
